<template>
  <div>
    <div class="table-responsive">
      <table class="table table-hover">
        <thead class="tw:text-left tw:text-sm tw:bg-zinc-50">
          <tr>
            <th>{{ $t('Item') }}</th>
            <th v-if="showRegistration" class="tw:hidden tw:md:table-cell tw:print:table-cell">{{ $t('Registration') }}</th>
            <th>{{ $t('Date') }}</th>
            <th class="tw:hidden tw:lg:table-cell tw:print:table-cell">{{ $t('Review') }}</th>
            <th class="tw:hidden tw:sm:table-cell tw:print:table-cell">{{ $t('Status') }}</th>
          </tr>
        </thead>
        <tbody>
          <ProductTestTableRow
            v-for="productTest in productTests"
            :key="productTest.id"
            :product-test="productTest"
            :show-product="showProduct"
            :show-equipment="showEquipment"
            :show-tour="showTour"
            :show-registration="showRegistration"
            :show-comment="showComment"
            @click="openModal(productTest)"
          ></ProductTestTableRow>
        </tbody>
      </table>
    </div>
    <Dialog :open="!! productTestDetails" @update:open="onDialogUpdate">
      <DialogScrollContent size="xl">
        <DialogHeader>
          <DialogTitle>
            {{ $t('Product test information') }}
          </DialogTitle>
        </DialogHeader>
        <ProductTestInformation v-if="!! productTestDetails"
                  :product-test-id="productTestDetails?.id"
                  @refresh="onRefreshProductTests"
        ></ProductTestInformation>
      </DialogScrollContent>
    </Dialog>
  </div>
</template>
<script setup>
import { ref, defineProps } from 'vue';
import ProductTestTableRow from "@/components/product-test/ProductTestTableRow.vue";
import ProductTestInformation from "@/components/product-test/ProductTestInformation.vue";
import { Dialog, DialogScrollContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const props = defineProps({
  productTests: {
    type: Array,
    required: true,
  },
  showProduct: {
    type: Boolean,
    default: false,
  },
  showEquipment: {
    type: Boolean,
    default: false,
  },
  showTour: {
    type: Boolean,
    default: false,
  },
  showRegistration: {
    type: Boolean,
    default: false,
  },
  showComment: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['refresh']);

const productTestDetails = ref(null);

const openModal = (productTest) => {
  productTestDetails.value = productTest;
};

const onDialogUpdate = (isOpen) => {
  if (!isOpen) {
    productTestDetails.value = null;
  }
};

const onRefreshProductTests = () => {
  emit('refresh');
};
</script>
